module.exports = __webpack_public_path__ + "media/listing/cat-placeholder-4a28f063.png";